import { downloadCollectionYardVisitReceiptThunk } from "../../reducers/collectionYardsReducer";
import { useAppDispatch } from "../../store";
import { Icon, IconNameEnum } from "../Icon";

export enum DownloadVariant {
  icon = "icon",
  button = "button",
}

interface DownloadCollectionYardVisitReceiptProps {
  visitId: number;
  variant: DownloadVariant;
  children?: React.ReactNode;
}

export const DownloadCollectionYardVisitReceipt: React.FC<DownloadCollectionYardVisitReceiptProps> = ({
  visitId,
  variant,
  children,
}) => {
  const dispatch = useAppDispatch();

  const handleDownload = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    dispatch(downloadCollectionYardVisitReceiptThunk(visitId));
  };

  if (variant === DownloadVariant.button) {
    return (
      <span onClick={handleDownload} role="button">
        {children}
      </span>
    );
  }

  return <Icon name={IconNameEnum.download} onClick={handleDownload} />;
};
